<template>
  <v-autocomplete dense single-line multiple clearable :menu-props="{maxHeight: 370}" v-model="formValue" :items="items" @input="emitValue" :rules="rules"></v-autocomplete>
</template>

<script>
  export default {
    props: {
      value: {
        type: [String, Array],
        required: true,
      },
      items: {
        type: Array,
        default: () => [],
      },
      rules: {
        type: Array,
        default: () => [],
      },
    },
    data() {
      return {
        formValue: [],
      }
    },
    watch: {
      value() {
        this.setFormValue()
      },
    },
    methods: {
      setFormValue() {
        this.formValue = Array.isArray(this.value) ?
          this.value : [this.value]
      },
      emitValue() {
        this.$emit('input', this.formValue)
      },
    },
    mounted() {
      this.setFormValue()
    },
  }
</script>